//Europe
import fr_BE from '@angular/common/locales/fr-BE';
import fr from '@angular/common/locales/fr';
import de from '@angular/common/locales/de';
import en_DE from '@angular/common/locales/en-DE';
import it from '@angular/common/locales/it';
import en_NL from '@angular/common/locales/en-NL';
import nl from '@angular/common/locales/nl';
import ro from '@angular/common/locales/ro';
import en_GB from '@angular/common/locales/en-GB';
import es from '@angular/common/locales/es';
//NA
import es_US from '@angular/common/locales/es-US';
import fr_CA from '@angular/common/locales/fr-CA';
import en_CA from '@angular/common/locales/en-CA';
import es_MX from '@angular/common/locales/es-MX';
import en from '@angular/common/locales/en';
//South America
import es_CO from '@angular/common/locales/es-CO';
//North Asia
import en_HK from '@angular/common/locales/en-HK';
import zh_HK from '@angular/common/locales/zh-Hant-HK';
import kr from '@angular/common/locales/ko';
import jp from '@angular/common/locales/ja';
import zh_Hant from '@angular/common/locales/zh-Hant';
//South Asia
import en_AU from '@angular/common/locales/en-AU';
import zh_Hans from '@angular/common/locales/zh-Hans';
import en_NZ from '@angular/common/locales/en-NZ';
import en_IN from '@angular/common/locales/en-IN';
import id from '@angular/common/locales/id';
import en_MY from '@angular/common/locales/en-MY';
import en_PH from '@angular/common/locales/en-PH';
import en_SG from '@angular/common/locales/en-SG';
import ms from '@angular/common/locales/ms';
import th from '@angular/common/locales/th';
//Targets
import {registerLocaleData} from "@angular/common";
import {CartLocaleData} from "./locale-data";
import {
    defineLocale,
    deLocale,
    enGbLocale,
    esLocale,
    frLocale,
    idLocale,
    itLocale,
    jaLocale,
    koLocale,
    nlLocale,
    roLocale,
    thLocale,
    zhCnLocale
} from "ngx-bootstrap/chronos";

export class RegisterAngularLocales {

    static LOCALE_MAP = new Map<string[], CartLocaleData>([
        //Europe
        [["fr-BE"], {angularLocale: fr_BE}],
        [["fr-FR"], {angularLocale: fr, chronosLocale: frLocale}],
        [["de-DE"], {angularLocale: de, chronosLocale: deLocale}],
        [["en-DE"], {angularLocale: en_DE, chronosLocale: deLocale}],
        [["en-ES"], {angularLocale: en, chronosLocale: esLocale}], //generic
        [["en-IT"], {angularLocale: en, chronosLocale: itLocale}], //generic
        [["it-IT"], {angularLocale: it, chronosLocale: itLocale}],
        [["en-NL"], {angularLocale: en_NL, chronosLocale: nlLocale}],
        [["nl-NL"], {angularLocale: nl, chronosLocale: nlLocale}],
        [["ro-RO"], {angularLocale: ro, chronosLocale: roLocale}],
        [["en-RO"], {angularLocale: en, chronosLocale: roLocale}], //generic
        [["en-UK"], {angularLocale: en_GB, chronosLocale: enGbLocale}],
        [["es-ES"], {angularLocale: es, chronosLocale: esLocale}],

        //North America
        [["zh-US", "zht-US"], {angularLocale: zh_Hant}],
        [["zhs-US"], {angularLocale: zh_Hans}],
        [["es-US"], {angularLocale: es_US}],
        [["en-CA"], {angularLocale: en_CA, chronosLocale: enGbLocale}],
        [["fr-CA"], {angularLocale: fr_CA, chronosLocale: frLocale}],
        [["zh-CA"], {angularLocale: zh_Hant, chronosLocale: zhCnLocale}],
        [["es-MX"], {angularLocale: es_MX}],

        //South America
        [["es-CO"], {angularLocale: es_CO}],

        //North Asia
        [["en-HK"], {angularLocale: en_HK}],
        [["zh-HK"], {angularLocale: zh_HK}],
        [["zh-TW"], {angularLocale: zh_Hant}],
        [["kr-KR", "kr-US"], {angularLocale: kr, chronosLocale: koLocale}],
        [["jp-JP"], {angularLocale: jp, chronosLocale: jaLocale}],
        [["zh-CN"], {angularLocale: zh_Hans}],

        //South Asia
        [["en-AU"], {angularLocale: en_AU}],
        [["zh-AU"], {angularLocale: zh_Hant}],
        [["en-NZ"], {angularLocale: en_NZ}],
        [["zh-NZ"], {angularLocale: zh_Hant}],
        [["en-ID"], {angularLocale: id, chronosLocale: idLocale}],
        // registering both id-ID and in-ID because USANA uses id-ID as the usanaLocale for date formatting
        // java uses in-ID for the backend CurrencyConfig.locale for currency formatting
        [["id-ID"], {angularLocale: id, chronosLocale: idLocale}],
        [["in-ID"], {angularLocale: id, chronosLocale: idLocale}],
        [["en-MY"], {angularLocale: en_MY}],
        [["ms-MY"], {angularLocale: ms}],
        [["en-PH"], {angularLocale: en_PH}],
        [["en-SG"], {angularLocale: en_SG}],
        [["en-IN"], {angularLocale: en_IN}],
        [["th-TH"], {angularLocale: th, chronosLocale: thLocale}]
    ]);

    static registerLocales() {
        RegisterAngularLocales.LOCALE_MAP
            .forEach((cartLocaleData, usanaLocaleIds) => {
                usanaLocaleIds.forEach(usanaLocaleId => {
                    // Angular
                    if (cartLocaleData.angularLocale) {
                        registerLocaleData(cartLocaleData.angularLocale, usanaLocaleId);
                    }
                    // Chronos (Datepicker)
                    if (cartLocaleData.chronosLocale) {
                        defineLocale(usanaLocaleId.toLowerCase(), cartLocaleData.chronosLocale);
                    }
                });
            });
    }
}
